export default __webpack_public_path__ + "cfb0faf1f43c02ddc7036fd68ed7cd58.png";